// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceEmail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { PropTypes as ObservablePropTypes } from 'mobx-react';

const MyPreferenceEmail = (props: any) => {
  const {
    store: { model: currentUser },
    localization
  } = props;
  return (
    <GridLayout.Row>
      <GridLayout.Col cols='2'>
        <span className='u_controlHeight control-label'>{localization.getText('COMMON_LABEL_EMAIL')}</span>
      </GridLayout.Col>
      <GridLayout.Col cols='10'>
        <label className='u_controlHeight control-label'>{currentUser.emailAddress}</label>
      </GridLayout.Col>
    </GridLayout.Row>
  );
};
MyPreferenceEmail.propTypes = {
  store: ObservablePropTypes.observableObject.isRequired
};
export default connect()(MyPreferenceEmail);



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/MyPreference/Izenda.MyPreferenceEmail.jsx